import React, { useEffect, useState } from 'react';
import SpriteIcon from '../shared/sprite-icon';
import '../../scss/heart-animation.scss';

// -----------------------------------------------------------------------------
export const HeartAnimation = () => {
  const [hearts, setHearts] = useState<{ 
    id: number; left: number; animationDuration: number; animationDelay: number 
  }[]>([]);

  useEffect(() => {
    // Determine how many hearts to show based on standard random count
    const heartCount = Math.floor(Math.random() * 4) + 4; // 4 to 7 hearts
    
    const newHearts = Array.from({ length: heartCount }).map((_, i) => ({
      id: i,
      // Random starting position slightly offset from the center
      left: Math.random() * 40 - 20, 
      // Slight variation in animation duration
      animationDuration: 1.5 + Math.random() * 1.5,
      // Staggering the start time so they go one after another
      animationDelay: i * 0.3 + Math.random() * 0.2,
    }));
    
    setHearts(newHearts);
  }, []);

  return (
    <div className="heart-animation-container">
      {hearts.map((heart) => (
        <div
          key={heart.id}
          className="floating-heart"
          style={{
            left: `${heart.left}px`,
            animationDuration: `${heart.animationDuration}s`,
            animationDelay: `${heart.animationDelay}s`,
          }}
        >
          <SpriteIcon icon="heart" />
        </div>
      ))}
      {/* The main static heart that sits there */}
      <SpriteIcon icon="heart" svgClassName="static-heart" />
    </div>
  );
};
